import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Menu, MenuItem, Avatar, Typography, Box, Divider } from '@mui/material';
import { Person, Settings, Logout } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { Link as RouterLink } from 'react-router-dom';

const TopBar = () => {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}>
      <Toolbar>
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2">
            {user?.first_name} {user?.last_name}
          </Typography>
          <IconButton onClick={handleMenu} size="small">
            <Avatar 
              src={user?.picture} 
              alt={user?.first_name || 'User'}
              sx={{ width: 32, height: 32 }}
            />
          </IconButton>
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem component={RouterLink} to="/profile" onClick={handleClose}>
            <Person sx={{ mr: 2 }} /> Profile
          </MenuItem>
          <MenuItem component={RouterLink} to="/settings" onClick={handleClose}>
            <Settings sx={{ mr: 2 }} /> Settings
          </MenuItem>
          <Divider />
          <MenuItem onClick={async () => {
            handleClose();
            await logout();
          }} sx={{ color: 'error.main' }}>
            <Logout sx={{ mr: 2 }} /> Sign out
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
